<mat-card>
	<mat-card-title>Details</mat-card-title>
	<hr />
	<mat-card-content class="card-content">
		<div fxLayout="row" fxLayoutAlign="start center">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<mat-select
					[disabled]="payScale.payScaleId"
					name="airframe"
					required
					placeholder="Aircraft Model"
					[(ngModel)]="payScale.aircraftModelId"
					(ngModelChange)="isNeedChange()"
				>
					<mat-option *ngFor="let item of filteredAircraftModels" [value]="item.aircraftModelId">
						{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<mat-select
					[disabled]="payScale.payScaleId"
					name="jobtitle"
					required
					placeholder="Job Title"
					[(ngModel)]="payScale.jobTitleId"
					(ngModelChange)="isNeedChange()"
				>
					<mat-option *ngFor="let item of filteredJobTitles" [value]="item.jobTitleId">
						{{ item.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<input
					name="missionPay"
					matInput
					decimalOnly="twoDigitDecimalNumber"
					type="text"
					[(ngModel)]="payScale.perTripPay"
					placeholder="Trip Pay"
					(ngModelChange)="isNeedChange()"
					#characterCountHintExample
				/>
			</mat-form-field>
		</div>
		<div fxLayout="row" fxLayoutAlign="start center">
			<mat-form-field class="ml-xs mr-xs" style="width: 100%;">
				<input
					name="availabilityPay"
					matInput
					decimalOnly="twoDigitDecimalNumber"
					type="text"
					[(ngModel)]="payScale.availabilityPay"
					placeholder="Availability Pay"
					(ngModelChange)="isNeedChange()"
					#characterCountHintExample
				/>
			</mat-form-field>
		</div>
	</mat-card-content>
</mat-card>
